var _defs, _g;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFavicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 13.37 11.64",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#2a7de1;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Risorsa 1") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Livello_2",
    "data-name": "Livello 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Livello_1-2",
    "data-name": "Livello 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M11,3.22l0,0A39.91,39.91,0,0,1,7.36,7a2.21,2.21,0,0,1-1.54.59H5.67A1.72,1.72,0,1,1,7.49,5.39c.62-.6,1.47-1.51,2.72-2.85l.24-.25A5.82,5.82,0,0,0,0,5.82,5.66,5.66,0,0,0,.49,8.16,5.82,5.82,0,1,0,11,3.22"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M12.84,0H11.1a.54.54,0,0,0,0,1.07h1.2V2.27a.54.54,0,1,0,1.07,0V.54A.53.53,0,0,0,12.84,0"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavicon);
export default __webpack_public_path__ + "static/media/favicon.6249ad498d6b8a6fde58970ed49f2781.svg";
export { ForwardRef as ReactComponent };